import React from 'react'
import EtUserActionCenterWithTabsComp from "@/features/userActions/EtUserActionCenterWithTabsComp"; 

// 02 Dec 2025
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp"

const EtTrinityActionCenter = ({
  userId="",
  userOrgId="",
  onClose,
}) => {

  // First Created - 15 Nov 2025
  // Author - Atul Pandey
  // Purpose - Let user manage all their actions from one place
  // Updated - 02 Dec 2025 - Icon for Actions instead of Ligthening Bolt Icon


  return (
    <div className="p-6 bg-white shadow rounded font-poppins max-w-6xl mx-auto mt-4">
     <div className="flex justify-between items-center mb-4 animate-slide-in-left">
          <div>
            <div className="flex justify-start items-center">
                <EtWabActionIcon1SVGComp className="h-6 w-6 md:h-8 md:w-8 text-orange-600" />
                <p className="text-xl font-bold text-gray-800 mx-1 px-1">Action Center</p>
            </div>
            {/* <p className="text-xl font-bold text-gray-800">⚡⚡Action Center</p> */}
            <p className="text-sm text-gray-500">how are you stepping up your <span className="font-bold text-orange-800"> mission </span> performance....</p>
          </div>
          
          <button
            onClick={onClose}
            className="text-sm text-blue-600 hover:underline"
          >
            Close
          </button>
        </div>

         <EtUserActionCenterWithTabsComp userId={userId} />
    </div>
  )
}

export default EtTrinityActionCenter